module.exports = __webpack_public_path__ + "static/media/main-bg.ccf262ef.jpg";